import { useState } from "react";
import { useAuth } from "../auth/AuthContext";
import { Logo } from "./ModuleHome";
import { t } from "../i18n";

export function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await signIn(email, password);
    } catch {
      setError(t("auth.invalid"));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="login">
      <form className="card" onSubmit={submit}>
        <div className="login-brand">
          <Logo size={52} />
          <h1>{t("app.title")}</h1>
          <div className="muted">{t("app.system")}</div>
        </div>
        <div className="field">
          <label htmlFor="email">{t("auth.email")}</label>
          <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </div>
        <div className="field">
          <label htmlFor="password">{t("auth.password")}</label>
          <input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button className="btn" type="submit" disabled={busy}>{busy ? "…" : t("auth.signIn")}</button>
        {error && <div className="error">{error}</div>}
      </form>
    </div>
  );
}
